var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelixLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2399,
    height: 354,
    viewBox: "0 0 2399 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2045.29 48.3894V0H2100.86V45.7431C2100.86 149.705 2398.76 171.631 2398.76 304.702V353.848H2345.08V314.531C2345.08 200.741 2045.29 191.289 2045.29 48.3894Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2398.76 48.3894V0H2343.19V45.7431C2343.19 149.705 2045.29 171.631 2045.29 304.702V353.848H2098.97V314.531C2098.97 200.741 2398.76 191.289 2398.76 48.3894Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2095.95,
    y: 38.561,
    width: 252.154,
    height: 10.9632,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2095.95,
    y: 88.4634,
    width: 252.154,
    height: 10.9632,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2095.95,
    y: 254.032,
    width: 252.154,
    height: 10.9632,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2095.95,
    y: 306.216,
    width: 252.154,
    height: 10.9632,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 1.26611,
    width: 53.2357,
    height: 349.976,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 338.735,
    y: 1.35742,
    width: 53.2162,
    height: 349.867,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 635.42,
    y: 1.35742,
    width: 53.2162,
    height: 349.91,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 51.1557,
    y: 141.305,
    width: 294.063,
    height: 47.5928,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 673.917,
    y: 141.305,
    width: 207.799,
    height: 47.5928,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 673.917,
    y: 1.36572,
    width: 288.946,
    height: 47.6693,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 674.005,
    y: 303.644,
    width: 288.946,
    height: 47.5928,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1206.4,
    y: 1.35742,
    width: 53.2162,
    height: 349.91,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1749.4,
    y: 1.35742,
    width: 53.2162,
    height: 349.91,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1244.99,
    y: 303.644,
    width: 258.103,
    height: 47.5928,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelixLogo);
export default __webpack_public_path__ + "static/media/helix-logo.63da97ca00879d689df9a2ee4308311e.svg";
export { ForwardRef as ReactComponent };